import { Injectable } from '@angular/core'
import { LAYERS_ARRAY } from '@core/constants/layers.data'
import { environment } from '@env/environment'
import { LAYERS_INDICATORS_BUSINESS_NAME } from '../constants/layers-indicators-business-name.data'

@Injectable({
  providedIn: 'root',
})
//@todo, should not have hardcoded data in frontend
//@todo, should be saved in DB or CMS
export class BusinessNameService {
  appName = environment.appName
  getReadableIndicatorsName(name: string): string {
    return (
      LAYERS_INDICATORS_BUSINESS_NAME[this.appName].find((x) => x.api_name === name)
        ?.business_name || name
    )
  }

  getReadableLayerName(name: string): string {
    return LAYERS_ARRAY.find((x) => x.workspacename === name)?.name || name
  }
}
